import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import Plus from './icons/Plus';
import Phone from './icons/Phone';
import Laptop from './icons/Laptop';
import Light from './icons/Light';
import AirPump from './icons/AirPump';
import MiniProjector from './icons/MiniProjector';
import CoffeeMaker from './icons/CoffeeMaker';
import ElectricGrill from './icons/ElectricGrill';
import ElectricKettle from './icons/ElectricKettle';
import MiniFridge from './icons/MiniFridge';
import AirConditioner from './icons/AirConditioner';
import { useGlobal } from '@/utils/useGlobal';
import { Fragment } from 'react';

export default function B() {
    const { useLang, useState, useRouter } = useGlobal();
    const { t } = useLang('RV');
    const { locale } = useRouter();
    const [active, setActive] = useState(0);

    const arr = [
        {
            title: t('B_bar1'),
            // text: t('B_bar1_text'),
            text: t.rich('B_bar1_text', {
                bold: (text: string) => {
                    console.log('text', text);
                    return <span className="bold">{text}</span>;
                },
            }),
        },
        {
            title: t('B_bar2'),
            text: t('B_bar2_text'),
        },
        {
            title: t('B_bar3'),
            text: t('B_bar3_text'),
            hide: locale !== 'au',
        },
        {
            title: t('B_bar4'),
            text: t('B_bar4_text'),
        },
    ];

    const iconArr = [
        {
            icon: <Phone />,
            text: t('B_icon1'),
        },
        {
            icon: <Laptop />,
            text: t('B_icon2'),
        },
        {
            icon: <Light />,
            text: t('B_icon3'),
        },
        {
            icon: <AirPump />,
            text: t('B_icon4'),
        },
        {
            icon: <MiniProjector />,
            text: t('B_icon5'),
        },
        {
            icon: <CoffeeMaker />,
            text: t('B_icon6'),
        },
        {
            icon: <ElectricGrill />,
            text: t('B_icon7'),
        },
        {
            icon: <ElectricKettle />,
            text: t('B_icon8'),
        },
        {
            icon: <MiniFridge />,
            text: t('B_icon9'),
        },
        {
            icon: <AirConditioner />,
            text: t('B_icon10'),
        },
    ];

    const IMG_MAP: any = {
        us: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744360962320/2_pc.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744360962582/2_h5.png',
        },
        au: {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717074868450/2.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717074898027/2_M.jpg',
        },
    };

    const handleClickOut = (e: any) => {
        const outClsArr = ['bar-base', 'plus-icon', 'plus', 'bar-title', 'bar-toggle-box', 'toggle-title', 'toggle-text'];
        if (!outClsArr.includes(e.target?.className)) {
            setActive(-1);
        }
    };

    const handleClickBar = (e: any, k: number) => {
        e.stopPropagation();
        setActive(k === active ? -1 : k);
    };

    return (
        <div id="RV-B" className={`RV-B RV-box ${css['RV-B']}`} onClick={handleClickOut}>
            <div className="info-box">
                <p className="title">{t('B_title')}</p>
                <p className="desc">{t('B_desc')}</p>
            </div>
            <div className="img-box">
                <EFPicture
                    src={IMG_MAP[locale]?.pc || IMG_MAP.us.pc}
                    srcPad={IMG_MAP[locale]?.h5 || IMG_MAP.us.h5}
                    srcMobile={IMG_MAP[locale]?.h5 || IMG_MAP.us.h5}
                    alt={t('B_title')}
                />
                <ul className="bars">
                    {arr?.map((item: any, k: number) => (
                        <Fragment key={k}>
                            {!item.hide && (
                                <li className={`bar-box ${active === k ? 'active' : ''} box${k + 1} ${!locale.includes('au') ? 'us' : ''}`}>
                                    <div className="bar-base" onClick={(e: any) => handleClickBar(e, k)}>
                                        <div className="plus-icon">
                                            <Plus />
                                        </div>
                                        <div className="bar-title">{item.title}</div>
                                    </div>
                                    <div className="bar-toggle-box">
                                        <p className="toggle-title">{item.title}</p>
                                        <p className="toggle-text">{item.text}</p>
                                    </div>
                                </li>
                            )}
                        </Fragment>
                    ))}
                </ul>
            </div>
            <div className="icon-box">
                <ul className="icons">
                    {iconArr?.map((icon: any, k: number) => (
                        <li className="icon" key={k}>
                            <div className="icon-svg">{icon.icon}</div>
                            <p className="icon-text">{icon.text}</p>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
